import { FormControl, FormGroup, Validators } from '@angular/forms';

export type InvoiceRevenueAddressForm = FormGroup<{
  postalCode: FormControl<string>;
  district: FormControl<string>;
  state: FormControl<string>;
  city: FormControl<string>;
  streetAddress: FormControl<string>;
  number: FormControl<string>;
  address2: FormControl<string>;
  ibge: FormControl<string>;
  country: FormControl<string>;
  email: FormControl<string>;
}>;

export function createInvoiceRevenueAddressForm(): InvoiceRevenueAddressForm {
  return new FormGroup({
    postalCode: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.minLength(8)] }),
    district: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    state: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    city: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    streetAddress: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    number: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    address2: new FormControl('', { nonNullable: true }),
    ibge: new FormControl('', { nonNullable: true }),
    country: new FormControl('Brasil', { nonNullable: true, validators: [Validators.required] }),
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]*$')]
    }),
  });
}

